export default "__VITE_ASSET__DETSxdtz__"